import { render, staticRenderFns } from "./ProcessingsTimelineItem.vue?vue&type=template&id=987571a4&scoped=true&"
import script from "./ProcessingsTimelineItem.vue?vue&type=script&lang=js&"
export * from "./ProcessingsTimelineItem.vue?vue&type=script&lang=js&"
import style0 from "./ProcessingsTimelineItem.vue?vue&type=style&index=0&id=987571a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987571a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VIcon,VMenu,VRow})
